webpackJsonp([0],{

/***/ "0gqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cnliveLogo_vue__ = __webpack_require__("qYbc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b521d8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cnliveLogo_vue__ = __webpack_require__("8OJl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cnliveLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b521d8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cnliveLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "154F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_output_badge_vue__ = __webpack_require__("s6yP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9c92826_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_output_badge_vue__ = __webpack_require__("7kg/");
function injectStyle (ssrContext) {
  __webpack_require__("XExH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9c92826"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_output_badge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9c92826_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_output_badge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "479c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7kg/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('table',{staticStyle:{"background":"none","border-width":"0px","border":"0px","margin":"0","padding":"0"},attrs:{"cellpadding":"0","cellspacing":"0","border":"0"}},[_c('tr',[_c('td',{staticStyle:{"padding-top":"0","padding-bottom":"0","padding-left":"0","padding-right":"7px","border-top":"0","border-bottom":"0: border-left: 0"},attrs:{"valign":"top"}},[_c('a',{attrs:{"href":"https://www.cnlive18.com/"}},[_c('img',{staticStyle:{"width":"175px","max-width":"175px !175important","height":"96px","max-height":"96px !important"},attrs:{"width":"175","height":"96","id":"preview-image-url","src":"http://d6449bb3dc657045bfc9-290115cc0d6de62a29c33db202ae565c.r80.cf1.rackcdn.com/1583/CNLive_Convention_logo_new4.jpg","name":"preview-image-url"}})]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding-top":"5px"},attrs:{"colspan":"2"}},[_c('a',{staticStyle:{"border-width":"0px","border":"0px","text-decoration":"none"},attrs:{"href":"https://www.facebook.com/basementsystemsinc","target":"_blank"}},[_c('img',{staticStyle:{"border":"none","width":"25px","max-width":"25px !important","height":"25px","max-height":"25px !important"},attrs:{"width":"20","height":"20","src":"http://d6449bb3dc657045bfc9-290115cc0d6de62a29c33db202ae565c.r80.cf1.rackcdn.com/687/cnlive-fb.png"}})]),_vm._v("  "),_c('a',{staticStyle:{"border-width":"0px","border":"0px","text-decoration":"none"},attrs:{"href":"https://twitter.com/basementsystems","target":"_blank"}},[_c('img',{staticStyle:{"border":"none","width":"25px","max-width":"25px !important","height":"25px","max-height":"25px !important"},attrs:{"width":"20","height":"20","src":"http://d6449bb3dc657045bfc9-290115cc0d6de62a29c33db202ae565c.r80.cf1.rackcdn.com/687/cnlive-twitter.png"}})]),_vm._v("  "),_c('a',{staticStyle:{"border-width":"0px","border":"0px","text-decoration":"none"},attrs:{"href":"https://www.instagram.com/contractor.nation/","target":"_blank"}},[_c('img',{staticStyle:{"border":"none","width":"25px","max-width":"25px !important","height":"25px","max-height":"25px !important"},attrs:{"width":"20","height":"20","src":"http://d6449bb3dc657045bfc9-290115cc0d6de62a29c33db202ae565c.r80.cf1.rackcdn.com/687/cnlive-instagram.png"}})])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8OJl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('g',{attrs:{"fill":_vm.iconColorOne}},[_c('path',{staticClass:"cn-orange",attrs:{"d":"M24.1,59.8c-3.1,0-5.8-0.3-8-1c-2.2-0.7-4-1.6-5.4-2.8c-1.4-1.2-2.4-2.6-3-4.2c-0.6-1.6-0.9-3.4-0.9-5.4V17.7\n      c0-2,0.3-3.8,0.9-5.4c0.6-1.6,1.6-3,3-4.2C12,6.9,13.8,6,16,5.3s4.9-1,8-1h44.7v8.2H24.1c-4.6,0-6.9,1.7-6.9,5.1v28.8\n      c0,3.4,2.3,5.1,6.9,5.1h44.7v8.2H24.1z"}}),_vm._v(" "),_c('path',{staticClass:"cn-orange",attrs:{"d":"M145.8,59.8L86.7,16.6v43.2h-9.1V4.3h9.1l55.2,41.2V4.3h9.1v55.4H145.8z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":_vm.iconColorTwo}},[_c('path',{staticClass:"cn-white",attrs:{"d":"M161.2,59.8V4.3h10.6v47.3h45v8.2H161.2z"}}),_vm._v(" "),_c('path',{staticClass:"cn-white",attrs:{"d":"M224.4,59.8V4.3h10.5v55.4H224.4z"}}),_vm._v(" "),_c('path',{staticClass:"cn-white",attrs:{"d":"M277.2,59.8L240.4,4.3h11.9l29,44.7l28.7-44.7h11.6l-36.6,55.4H277.2z"}}),_vm._v(" "),_c('path',{staticClass:"cn-white",attrs:{"d":"M326.6,59.8V4.3h57v8.2h-46.5v13.9h44.2v8.2h-44.2v17h46.5v8.2H326.6z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8j5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_output_signature_vue__ = __webpack_require__("rhSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7206370c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_output_signature_vue__ = __webpack_require__("Av2R");
function injectStyle (ssrContext) {
  __webpack_require__("WtlI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7206370c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_output_signature_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7206370c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_output_signature_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9V+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_information_vue__ = __webpack_require__("vPwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c28095e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_information_vue__ = __webpack_require__("K9D4");
function injectStyle (ssrContext) {
  __webpack_require__("479c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c28095e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c28095e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Av2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('table',{staticStyle:{"background":"none","border-width":"0px","border":"0px","margin":"0","padding":"0"},attrs:{"cellpadding":"0","cellspacing":"0","border":"0"}},[_c('tr',[_c('td',{staticStyle:{"padding-top":"0","padding-bottom":"0","padding-left":"0","padding-right":"7px","border-top":"0","border-bottom":"0: border-left: 0"},attrs:{"valign":"top"}},[_c('a',{attrs:{"href":"https://www.masterservicestn.com"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobilePhoneSwitch),expression:"mobilePhoneSwitch"}],staticStyle:{"width":"220px","max-width":"220px !important","height":"139px","max-height":"139px !important","margin-top":"5px"},attrs:{"width":"220","height":"139","id":"preview-image-url","src":"https://cdn.treehouseinternetgroup.com/cms_images/195/signature-logo-bar-master.jpg","name":"preview-image-url"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobilePhoneSwitch),expression:"!mobilePhoneSwitch"}],staticStyle:{"width":"190px","max-width":"190px !important","height":"121px","max-height":"121px !important","margin-top":"5px"},attrs:{"width":"190","height":"121","id":"preview-image-url","src":"https://cdn.treehouseinternetgroup.com/cms_images/195/signature-logo-bar-master.jpg","name":"preview-image-url"}})])]),_vm._v(" "),_c('td',{staticStyle:{"padding-top":"0","padding-bottom":"0","padding-left":"5px","padding-right":"0"}},[_c('table',{staticStyle:{"background":"none","border-width":"0px","border":"0px","margin":"0","padding":"0"},attrs:{"cellpadding":"0","cellspacing":"0","border":"0"}},[_c('tr',[_c('td',{staticStyle:{"padding-bottom":"5px","color":"#00345c","font-size":"18px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"colspan":"2"}},[_vm._v("\n                "+_vm._s(_vm.fullName)+"\n                ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"color":"#333333","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"colspan":"2"}},[_c('em',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobilePhoneSwitch),expression:"!mobilePhoneSwitch"}]}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"vertical-align":"top","width":"20px","color":"#00345c","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"width":"20","valign":"top"}},[_vm._v("\n                Office:\n                ")]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"top","color":"#333333","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"valign":"top"}},[_vm._v("\n                "+_vm._s(_vm.phone)+"\n                ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobilePhoneSwitch),expression:"mobilePhoneSwitch"}]},[_c('td',{staticStyle:{"vertical-align":"top","width":"20px","color":"#00345c","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"width":"20","valign":"top"}},[_vm._v("\n                Mobile:\n                ")]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"top","color":"#333333","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"valign":"top"}},[_vm._v("\n                "+_vm._s(_vm.mobilePhone)+"\n                ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"vertical-align":"top","width":"20px","color":"#00345c","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"width":"20","valign":"top"}},[_vm._v("\n                  Email:\n                  ")]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"top","color":"#333333","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"valign":"top"}},[_c('a',{staticStyle:{"color":"#333333","text-decoration":"none","font-weight":"normal","font-size":"14px"},attrs:{"href":("mailto:" + (this.email))}},[_vm._v(_vm._s(_vm.email))]),_vm._v("\n                      \n                  ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"10px","color":"#00345c","line-height":"12px","text-align":"left","width":"450px"},attrs:{"width":"450"}},[_vm._v("This message contains confidential information and is intended only for the intended recipients. If you are not an intended recipient you should not disseminate, distribute or copy this e-mail. Please notify us immediately by e-mail if you have received this e-mail by mistake and delete this e-mail from your system. E-mail transmission cannot be guaranteed to be secure or error-free as information could be intercepted, corrupted, lost, destroyed, arrive late or incomplete, or contain viruses. Therefore we do not accept liability for any errors or omissions in the contents of this message, which arise as a result of e-mail transmission. If verification is required please request a hard-copy version.")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"vertical-align":"top","width":"20px","color":"#00345c","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"width":"20","valign":"top"}},[_vm._v("\n                Web:\n                ")]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"top","color":"#333333","font-size":"14px","font-family":"Arial, Helvetica, sans-serif"},attrs:{"valign":"top"}},[_c('a',{staticStyle:{"color":"#333333","text-decoration":"none","font-weight":"normal","font-size":"14px"},attrs:{"href":"https://www.masterservicestn.com","target":"_blank"}},[_vm._v("\n                  masterservicestn.com")]),_vm._v("\n                    \n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"padding-top":"5px"},attrs:{"colspan":"2"}},[_c('a',{staticStyle:{"border-width":"0px","border":"0px","text-decoration":"none"},attrs:{"href":"https://www.facebook.com/TheMasterTeamTN","target":"_blank"}},[_c('img',{staticStyle:{"border":"none","width":"25px","max-width":"25px !important","height":"25px","max-height":"25px !important"},attrs:{"width":"25","height":"25","src":"https://dc69b531ebf7a086ce97-290115cc0d6de62a29c33db202ae565c.ssl.cf1.rackcdn.com/2822/icon-facebook_30x30-2.png"}})]),_vm._v(" "),_c('a',{staticStyle:{"border-width":"0px","border":"0px","text-decoration":"none"},attrs:{"href":"https://www.linkedin.com/company/masterservicestn","target":"_blank"}},[_c('img',{staticStyle:{"border":"none","width":"25px","max-width":"25px !important","height":"25px","max-height":"25px !important"},attrs:{"width":"25","height":"25","src":"https://dc69b531ebf7a086ce97-290115cc0d6de62a29c33db202ae565c.ssl.cf1.rackcdn.com/2822/icon-linkedin_30x30-2.png"}})]),_vm._v(" "),_c('a',{staticStyle:{"border-width":"0px","border":"0px","text-decoration":"none"},attrs:{"href":"https://www.youtube.com/channel/UCop6hiVtGvTDem0UqPppINw","target":"_blank"}},[_c('img',{staticStyle:{"border":"none","width":"25px","max-width":"25px !important","height":"25px","max-height":"25px !important"},attrs:{"width":"25","height":"25","src":"https://dc69b531ebf7a086ce97-290115cc0d6de62a29c33db202ae565c.ssl.cf1.rackcdn.com/2822/icon-youtube_30x30.png"}})]),_vm._v(" "),_c('a',{staticStyle:{"border-width":"0px","border":"0px","text-decoration":"none"},attrs:{"href":"https://www.instagram.com/masterserviceteam/","target":"_blank"}},[_c('img',{staticStyle:{"border":"none","width":"25px","max-width":"25px !important","height":"25px","max-height":"25px !important"},attrs:{"width":"25","height":"25","src":"https://dc69b531ebf7a086ce97-290115cc0d6de62a29c33db202ae565c.ssl.cf1.rackcdn.com/2822/icon-instagram_30x30.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Imx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    iconName: {
      type: String,
      default: 'logo'
    },
    width: {
      type: [Number, String],
      default: 350
    }
  }
});

/***/ }),

/***/ "K9D4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit($event)}}},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left has-icons-right"},[_c('input',{staticClass:"input",attrs:{"onblur":"if (this.value == '') {this.value = 'Full Name';}","onfocus":"if (this.value == 'Full Name') {this.value = '';}","type":"text"},domProps:{"value":_vm.fullName},on:{"input":function($event){_vm.$emit('update:fullName', $event.target.value)}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left has-icons-right"},[_c('input',{staticClass:"input",attrs:{"onblur":"if (this.value == '') {this.value = 'Title';}","onfocus":"if (this.value == 'Title') {this.value = '';}","type":"text"},domProps:{"value":_vm.title},on:{"input":function($event){_vm.$emit('update:title', $event.target.value)}}}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobilePhoneSwitch),expression:"!mobilePhoneSwitch"}]}),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left has-icons-right"},[_c('input',{staticClass:"input",attrs:{"onblur":"if (this.value == '') {this.value = 'Office';}","onfocus":"if (this.value == 'Office') {this.value = '';}","type":"text"},domProps:{"value":_vm.phone},on:{"input":function($event){_vm.$emit('update:phone', $event.target.value)}}}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobilePhoneSwitch),expression:"mobilePhoneSwitch"}]},[_c('div',{staticClass:"field",staticStyle:{"margin-bottom":".75rem"}},[_c('div',{staticClass:"control has-icons-left has-icons-right"},[_c('input',{staticClass:"input",attrs:{"onblur":"if (this.value == '') {this.value = 'Mobile';}","onfocus":"if (this.value == 'Mobile') {this.value = '';}","type":"text"},domProps:{"value":_vm.mobilePhone},on:{"input":function($event){_vm.$emit('update:mobilePhone', $event.target.value)}}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left has-icons-right"},[_c('input',{staticClass:"input",attrs:{"onblur":"if (this.value == '') {this.value = 'Email';}","onfocus":"if (this.value == 'Email') {this.value = '';}","type":"text"},domProps:{"value":_vm.email},on:{"input":function($event){_vm.$emit('update:email', $event.target.value)}}}),_vm._v(" "),_vm._m(4)])])])]),_vm._v(" "),_c('button',{on:{"click":_vm.changeTitle}},[_vm._v("Add/Remove: Mobile Phone")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-id-badge"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-phone"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-mobile fa-lg"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-envelope"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b37466c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("nlDt");
function injectStyle (ssrContext) {
  __webpack_require__("mH8z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b37466c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b37466c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_information_vue__ = __webpack_require__("9V+V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_output_signature_vue__ = __webpack_require__("8j5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_output_badge_vue__ = __webpack_require__("154F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_IconBase_vue__ = __webpack_require__("sf9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_cnliveLogo_vue__ = __webpack_require__("0gqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('inputInformation', __WEBPACK_IMPORTED_MODULE_2__components_input_information_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('outputSignature', __WEBPACK_IMPORTED_MODULE_3__components_output_signature_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('outputBadge', __WEBPACK_IMPORTED_MODULE_4__components_output_badge_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('IconBase', __WEBPACK_IMPORTED_MODULE_5__components_IconBase_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('cnliveLogo', __WEBPACK_IMPORTED_MODULE_6__components_icons_cnliveLogo_vue__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "WtlI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XExH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "deuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"viewBox":"0 0 391 65","aria-labelledby":_vm.iconName,"role":"presentation"}},[_c('title',{attrs:{"id":_vm.iconName,"lang":"en"}},[_vm._v(_vm._s(_vm.iconName)+" icon")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "goAt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mH8z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nlDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container main"},[_c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",attrs:{"id":"input-info"}},[_c('h3',{staticClass:"subtitle"},[_vm._v("Input Information")]),_vm._v(" "),_c('inputInformation',{attrs:{"fullName":_vm.fullName,"title":_vm.title,"mobilePhone":_vm.mobilePhone,"phone":_vm.phone,"email":_vm.email,"mobilePhoneSwitch":_vm.mobilePhoneSwitch},on:{"update:fullName":function($event){_vm.fullName=$event},"update:title":function($event){_vm.title=$event},"update:mobilePhone":function($event){_vm.mobilePhone=$event},"update:phone":function($event){_vm.phone=$event},"update:email":function($event){_vm.email=$event},"update:mobilePhoneSwitch":function($event){_vm.mobilePhoneSwitch=$event},"changeTitle":function($event){_vm.updateTitle($event)}}}),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobilePhoneSwitch),expression:"!mobilePhoneSwitch"}],staticClass:"button is-success",attrs:{"type":"submit","disabled":!_vm.isValid},on:{"click":function($event){_vm.toggleShow, _vm.$modal.show('output')}}},[_vm._v("\n        Copy Signature\n    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobilePhoneSwitch),expression:"mobilePhoneSwitch"}],staticClass:"button is-success",attrs:{"type":"submit","disabled":!_vm.isValidAss},on:{"click":function($event){_vm.toggleShow, _vm.$modal.show('output')}}},[_vm._v("\n        Copy Signature\n    ")]),_vm._v(" "),_c('button',{staticClass:"button is-success",attrs:{"type":"submit","disabled":!_vm.isReset},on:{"click":function($event){$event.preventDefault();_vm.reset($event)}}},[_vm._v("\n        Reset\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('h3',{staticClass:"subtitle"},[_vm._v("Output Signature")]),_vm._v(" "),_c('outputSignature',{attrs:{"fullName":_vm.fullName,"title":_vm.title,"mobilePhone":_vm.mobilePhone,"phone":_vm.phone,"email":_vm.email,"mobilePhoneSwitch":_vm.mobilePhoneSwitch},on:{"update:fullName":function($event){_vm.fullName=$event},"update:title":function($event){_vm.title=$event},"update:mobilePhone":function($event){_vm.mobilePhone=$event},"update:phone":function($event){_vm.phone=$event},"update:email":function($event){_vm.email=$event},"update:mobilePhoneSwitch":function($event){_vm.mobilePhoneSwitch=$event},"changeTitle":function($event){_vm.updateTitle($event)}}})],1)])]),_vm._v(" "),_c('modal',{attrs:{"name":"output","height":500}},[_c('div',{staticClass:"sign-box level-item has-text-centered"},[_c('div',{staticClass:"output-btn"},[_c('p',{staticClass:"field"},[_c('a',{staticClass:"button is-small",on:{"click":function($event){_vm.$modal.hide('output')}}},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-times"})])])])]),_vm._v(" "),_c('outputSignature',{attrs:{"fullName":_vm.fullName,"title":_vm.title,"mobilePhone":_vm.mobilePhone,"phone":_vm.phone,"email":_vm.email,"mobilePhoneSwitch":_vm.mobilePhoneSwitch},on:{"update:fullName":function($event){_vm.fullName=$event},"update:title":function($event){_vm.title=$event},"update:mobilePhone":function($event){_vm.mobilePhone=$event},"update:phone":function($event){_vm.phone=$event},"update:email":function($event){_vm.email=$event},"update:mobilePhoneSwitch":function($event){_vm.mobilePhoneSwitch=$event},"changeTitle":function($event){_vm.updateTitle($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"gif-box level-item has-text-centered"},[_c('ul',[_c('li',[_vm._v("1. Place cursor at the top-left corner of Master Services logo and click & drag to bottom-right corner of the disclaimer")]),_vm._v(" "),_c('li',[_vm._v("2. Paste into Outlook signatures in preferences panel")]),_vm._v(" "),_c('li',[_vm._v("3. Adjust logo size if needed")])]),_vm._v(" "),_c('img',{attrs:{"src":"http://d6449bb3dc657045bfc9-290115cc0d6de62a29c33db202ae565c.r80.cf1.rackcdn.com/687/sign-copy3.gif","alt":""}})])])],1),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-primary"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"th-logo has-text-centered"},[_c('img',{staticStyle:{"width":"250px"},attrs:{"src":"https://cdn.treehouseinternetgroup.com/cms_images/195/Master%202025_RGB.png","alt":""}})]),_vm._v(" "),_c('h1',{staticClass:"sub-text title has-text-centered"},[_c('p',[_vm._v("Signature Generator")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("\n                    ©2025 Master Service Companies\n                ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qYbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    iconColorOne: {
      type: String,
      default: '#FF7F30'
    },
    iconColorTwo: {
      type: String,
      default: '#FFF'
    }
  }
});

/***/ }),

/***/ "rhSM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'outputSignature',
  props: {
    fullName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    mobilePhone: {
      type: String,
      required: true
    },
    phone: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    mobilePhoneSwitch: {
      type: Boolean,
      required: true
    }
  }
});

/***/ }),

/***/ "s6yP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'outputBadge'
});

/***/ }),

/***/ "sf9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconBase_vue__ = __webpack_require__("Imx1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd21beb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconBase_vue__ = __webpack_require__("deuE");
function injectStyle (ssrContext) {
  __webpack_require__("goAt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fd21beb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconBase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd21beb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconBase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vPwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inputInformation',
  props: {
    fullName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    mobilePhone: {
      type: String,
      required: true
    },
    phone: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    mobilePhoneSwitch: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    changeTitle: function changeTitle() {
      this.$emit('changeTitle', this.mobilePhoneSwitch = !this.mobilePhoneSwitch);
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      fullName: 'Full Name',
      title: 'Title',
      mobilePhone: 'Mobile',
      phone: 'Office',
      email: 'Email',
      isShowing: false,
      mobilePhoneSwitch: false
    };
  },
  computed: {
    isValid: function isValid() {
      return this.fullName !== 'Full Name' && this.title !== 'Title' && this.phone !== 'Office' && this.email !== 'Email';
    },
    isValidAss: function isValidAss() {
      return this.fullName !== 'Full Name' && this.title !== 'Title' && this.mobilePhone !== 'Mobile' && this.phone !== 'Office' && this.email !== 'Email';
    },
    isReset: function isReset() {
      return this.fullName !== 'Full Name' || this.title !== 'Title' || this.mobilePhone !== 'Mobile' || this.phone !== 'Office' || this.email !== 'Email';
    }
  },
  methods: {
    toggleShow: function toggleShow() {
      this.isShowing = !this.isShowing;
    },
    show: function show() {
      this.$modal.show('output');
    },
    hide: function hide() {
      this.$modal.hide('output');
    },
    reset: function reset() {
      this.fullName = 'Full Name';
      this.title = 'Title';
      this.mobilePhone = 'Mobile';
      this.phone = 'Office';
      this.email = 'Email';
    },
    updateTitle: function updateTitle(updatedTitle) {
      this.mobilePhoneSwitch = updatedTitle;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f82ce8dd6034642a94ec.js